import { IPromise } from 'angular';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { assertUnreachable } from '../../../../ts/helpers/TypescriptHelpers';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { Databases } from '../../../../ts/resources/Databases';
import { Tables } from '../../../../ts/resources/Tables';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import { ModalInstance, ReactModalService } from '../../../../ts/services/ReactModalService';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetDescriptionAction } from '../../../actions/spaces/SetDescriptionAction';
import { DescriptionDialogProps, descriptionDialogProps, DescriptionDialogState } from '../../../content/DescriptionDialog';
import { ServiceLocator } from '../../../ServiceLocator';
import { isSubmitOrCancelButtonClicked, SubmitOrCancelButtonClicked } from '../../../utils/SubmitOrCancel';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function* handleSetDescription(action: SetDescriptionAction) {
  try {
    const result: SubmitOrCancelButtonClicked | any = yield call(openDescriptionDialog, action.item);
    if (isSubmitOrCancelButtonClicked(result)) {
      switch (result) {
        case SubmitOrCancelButtonClicked.cancelled: break;
        case SubmitOrCancelButtonClicked.submitted: {
          const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
          if (!maybeReloaded) {
            yield put(requestSpaceContents());
          }
          break;
        }
        default: assertUnreachable(result);
      }
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function setDescription(item: IContentInfo<'database'> | IContentInfo<'table'>, state: DescriptionDialogState): Promise<IResult> {
  switch(item.contentType) {
    case 'database': return ServiceLocator.get<Databases>('Databases').setDatabaseDescription({
      description: state.description,
      id: item.vizportalId,
    });
    case 'table': return ServiceLocator.get<Tables>('Tables').setTableDescription({
      description: state.description,
      id: item.vizportalId,
    });
    default: assertUnreachable(item);
  }
}

export function openDescriptionDialog(item: IContentInfo<'database'> | IContentInfo<'table'>): IPromise<any> {
  let modalInstance: ModalInstance;

  const props: DescriptionDialogProps = {
    initial: { description: item.description || '' },
    submit: (args: DescriptionDialogState) => setDescription(item, args).then(() => modalInstance && modalInstance.close('submitted' as SubmitOrCancelButtonClicked)),
    cancel: () => modalInstance && modalInstance.close('cancelled' as SubmitOrCancelButtonClicked),
  };

  modalInstance = ReactModalService.open(descriptionDialogProps(props));
  return modalInstance.result;
}
